import { render } from "./FormCheck.vue?vue&type=template&id=48881425&scoped=true&ts=true"
import script from "./FormCheck.vue?vue&type=script&lang=ts"
export * from "./FormCheck.vue?vue&type=script&lang=ts"

import "./FormCheck.vue?vue&type=style&index=0&id=48881425&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48881425"]])

export default __exports__